import {ProductHighlight} from '.'
import {mapHighlights} from './helpers'

export const ProductHighlights = ({marginTop = [80, 100, 180], ...rest}) => {
	const highlights = mapHighlights({marginTop, ...rest})
	return highlights.map(ProductHighlight)
}
